import { Component, OnInit } from '@angular/core';
import {
  TableData,
  TablesComponent,
} from '../../components/tables/tables.component';
import { CommonModule, DatePipe } from '@angular/common';
import {
  AdminReportFilterModel,
  ReportService,
} from '../../../core/services/report/report.service';
import { TranslateService } from '@ngx-translate/core';
import { ColumnModel } from '../../../core/models/table/column.model';
import { FilterModel } from '../../../core/models/filters/filters.model';
import { SortModel } from '../../../core/models/filters/sort.model';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-analysis-report-list',
  standalone: true,
  imports: [TablesComponent, CommonModule, DatePipe],
  templateUrl: './analysis-report-list.component.html',
  styleUrl: './analysis-report-list.component.scss',
  providers: [DatePipe],
})
export class AnalysisReportListComponent implements OnInit {
  maxDate: string;
  tableHeader: string;
  columns: ColumnModel[] = [];
  data: TableData[] = [];

  totalCount: number = 0;
  totalPage: number = 0;
  pageSize: number = 10;
  pageSizes = [10, 25, 50, 100];
  currentPage: number = 1;
  url: string = `${environment.apiLocations.patient}/OrganizationAdminReport/GetAnalysisReportCountByCustomer`;

  filterModel: AdminReportFilterModel = {
    year: null,
    month: null,
  };

  filters: FilterModel[] = [

    //Year
    {
      type: 'date',
      label: 'year',
      placeholder: 'dd-mm-yyyy',
      filterId: 'Year',
      value: null,
    },
    //Month
    {
      type: 'date',
      label: 'month',
      placeholder: 'dd-mm-yyyy',
      filterId: 'Month',
      value: null,
    },
  ];

  constructor(
    private reportService: ReportService,
    private translate: TranslateService
  ) {
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];

    this.columns = [
      { key: 'year', translateKey: 'year' },
      { key: 'month', translateKey: 'month' },
      { key: 'totalImageCount', translateKey: 'totalImageCount' },
      { key: 'totalAnalysisCount', translateKey: 'totalAnalysisCount' },
    ];

    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
    setTimeout(() => {
      this.tableHeader = this.translate.instant('analysisReport');
    }, 100);
  }
  ngOnInit(): void {
    // this.getAnalysisReportCountByCustomer(this.currentPage, this.pageSize);
  }

  getAnalysisReportCountByCustomer(
    page: number,
    size: number,
    filters?: FilterModel[],
    sort?: SortModel
  ): void {
    this.reportService
      .getAnalysisReportCountByCustomer(page, size, filters, sort)
      .subscribe({
        next: (res) => {
          this.data = res.items;
          this.totalCount = res.count;
          this.totalPage = res.pages;
          this.pageSize = res.size;
          this.currentPage = page;
        },
      });
  }

  onChangeFilterValues(filters?: FilterModel[], sort?: SortModel) {
    this.getAnalysisReportCountByCustomer(1, this.pageSize, filters, sort);
  }

  changePage(e: any): void {
    if (e.page > 0 && e.page <= this.totalPage) {
      this.getAnalysisReportCountByCustomer(
        e.page,
        e.pageSize,
        this.filters
      );
    }
  }
}
